import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../store";

export interface GlobalModals {
  depositModal: boolean;
  withdrawModal: boolean;
  isPendingVerificationModalOpen: boolean;
}

const initialState: GlobalModals = {
  depositModal: false,
  withdrawModal: false,
  isPendingVerificationModalOpen: false,
};

const GlobalModalsSlice = createSlice({
  name: "globalModals",
  initialState: initialState,
  reducers: {
    setDepositModal: (state: GlobalModals, action: PayloadAction<boolean>): void => {
      state.depositModal = action.payload;
    },
    setWithdrawModal: (state: GlobalModals, action: PayloadAction<boolean>): void => {
      state.withdrawModal = action.payload;
    },
    setPendingVerificationModal: (state: GlobalModals, action: PayloadAction<boolean>): void => {
      state.isPendingVerificationModalOpen = action.payload;
    },
  },
});

export const { setDepositModal, setWithdrawModal, setPendingVerificationModal } =
  GlobalModalsSlice.actions;

export const useGlobalModalsSlice = () => useAppSelector((state) => state.globalModals);

export default GlobalModalsSlice;
